import styled, { css } from '@xstyled/styled-components'

interface RatioPaddingProps {
  ratio: number
}

export const RatioPadding = styled.div.attrs<RatioPaddingProps>((props) => ({
  style: {
    paddingBottom: (props.ratio * 100).toString().concat('%'),
  },
}))<RatioPaddingProps>`
  width: 100%;
`
